jQuery(document).ready(function ($) {
  $(".nav-toggle").on("click", function () {
    $(this).addClass("invisible");

    $(".nav-contact")
      .css({
        display: "flex",
      })
      .addClass("animated flipInX");
    $(".nav-top").css({
      display: "flex",
    });
    $(".nav-brand")
      .css({
        position: "fixed",
        "background-color": "white",
        left: "0",
        right: "0",
        "z-index": "980",
        top: "0",
        display: "flex",
        "justify-content": "center",
        padding: "10px",
      })
      .addClass("animated fadeInDown");
    $(".nav-close").css({
      display: "flex",
      "z-index": "999",
      position: "fixed",
    });
    $(".nav-primary nav")
      .css({
        display: "flex",
      })
      .addClass("animated flipInX");
  });

  $(".nav-close").on("click", function () {
    $(".nav-top").removeAttr("style").removeClass("animated flipInX");
    $(".nav-top nav").removeAttr("style").removeClass("animated fadeInUp");
    $(".nav-brand").removeAttr("style");
    $(".nav-contact").removeAttr("style");
    $(".nav-primary nav").toggleClass("flipInX flipOutX");
    setTimeout(function () {
      $(".nav-primary nav")
        .removeAttr("style")
        .removeClass("animated flipOutX");
    }, 800);
    $(".nav-close").removeAttr("style");
    $(".nav-toggle").removeClass("invisible");
  });
});
